import { useMemo } from "react";
import { genericMemo, prettifyEnumLabel } from "../../../utils";
import { SimpleSelect, SimpleSelectProps } from "./SimpleSelect";

export type EnumSelectProps<T, E = any> = Omit<SimpleSelectProps<T>, "setOptionLabel"> & {
  enumType?: E,
  setOptionLabel?: (option: E) => any,
}

export const EnumSelect = genericMemo(<T extends any, E>({ enumType, setOptionLabel, ...props }: EnumSelectProps<T, E>) => {
  return (
    <SimpleSelect
      options={useMemo(() => Object.values(enumType || {}) as T[], [ enumType ])}
      placeholder="Choose..."
      setOptionLabel={setOptionLabel || prettifyEnumLabel as any}
      {...props}
    />
  );
});


export default EnumSelect;
